let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5VPlL")).then(() => parcelRequire('f5xPm'));